<template>
    <!-- 警告组件 -->
    <el-slider 
    v-model="value" 
    :show-tooltip="tip"
    :format-tooltip="formatTip"
    :disabled="disabled"
    :step="step"
    :show-stops="stops"
    :show-input="showInput"
    :max="max"
    :min="min"
    :marks="marks"
    :show-input-controls="inputCtrl"
    :input-size="inputSize"
    :range="isRange"
    :vertical="vertical"
    :height="height"
    :label="label"
    :debounce="debounce"
    :tooltip-class="tipClass"
    @change="change"
    @input="input"
    />
</template>
<script>
export default {
    name:"VelSlider",
    props:{
        initValue:Number,
        formatTip:Function,
        step:Number,
        max:Number,
        min:Number,
        inputSize:String,
        height:String,
        label:String,
        debounce:Number,
        tipClass:String,
        marks:Object,
        isTip:Boolean,
        isDisable:Boolean,
        isVertical:Boolean,
        isRange:Boolean,
        isStops:Boolean,
        isInput:Boolean,
        isInputCtrl:Boolean,
    },
    data() {
        return {
            value:0,
            tip:false,
            disabled:false,
            vertical:false,
            range:false,
            stops:false,
            showInput:false,
            inputCtrl:false,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isTip ? this.tip = true : this.tip
            this.isDisable ? this.disabled = true : this.disabled
            this.isVertical ? this.vertical = true : this.vertical
            this.isRange ? this.range = true : this.range
            this.isStops ? this.stops = true : this.stops
            this.isInput ? this.showInput = true : this.showInput
            this.isInputCtrl ? this.inputCtrl = true : this.inputCtrl
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = 0
        },
        change(val){
            this.$emit('change',val)
        },
        input(val){
            this.$emit('input',val)
        }
    }
}
</script>